var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D5AFE",
    d: "M15.822 9v1.828h-2.811v1.194c2.277.103 3.989.544 3.989 1.073 0 .529-1.713.97-3.99 1.072V18h-2.003v-3.832C8.721 14.068 7 13.625 7 13.095c0-.53 1.721-.973 4.007-1.073v-1.194H8.195V9h7.627Zm-2.811 4.71c1.797-.082 3.128-.374 3.128-.723s-1.331-.642-3.13-.723v1.104a19.322 19.322 0 0 1-2.004.001v-1.108c-1.806.08-3.146.374-3.146.724s1.34.644 3.146.724l.12.005c.12.005.242.008.365.011h.011l.104.002h.03l.087.002h.557l.088-.002h.031l.112-.002h.005l.246-.007h.012l.109-.004h.012l.117-.005Z",
    className: "fill-primary-main"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    stroke: "#fff",
    fill: "none",
    cx: 12,
    cy: 12,
    r: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D5AFE",
    d: "M15 6h6m-3-3v6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdt);
export default __webpack_public_path__ + "static/media/icon_usdt.9a2f5328ab3998dcb95c065b239d29dd.svg";
export { ForwardRef as ReactComponent };